export default {"src":"/_next/static/media/tagea-logo.481ba007.svg","height":83,"width":203,"blurWidth":0,"blurHeight":0};